<div class="password-strength-container">
  <span class="password-strength-text">Password strength</span>
  <div class="progress password-strength-bar">
    <div [class]="getProgressBarClass()" role="progressbar"
         [style.width]="getProgressBarWidth()"
         [style.backgroundColor]="getStrengthLabelColor()"
         aria-valuemin="0" aria-valuemax="5"></div>
  </div>
  <div class="password-strength-label" [style.color]="getStrengthLabelColor()">
    <span>{{ getStrengthLabelText() }}</span>
  </div>
</div>
<div class="password-criteria">
  <h3 class="password-requirements-heading">Your password must have:</h3>
  <p [class.criteria-met]="criteria.lengthMet">
    <fa-icon *ngIf="criteria.lengthMet" [icon]="faCheck"></fa-icon>
    At least 8 characters
  </p>
  <p [class.criteria-met]="criteria.hasUppercase">
    <fa-icon *ngIf="criteria.hasUppercase" [icon]="faCheck"></fa-icon>
    1 Uppercase letter
  </p>
  <p [class.criteria-met]="criteria.hasLowercase">
    <fa-icon *ngIf="criteria.hasLowercase" [icon]="faCheck"></fa-icon>
    1 Lowercase letter
  </p>
  <p [class.criteria-met]="criteria.hasNumber">
    <fa-icon *ngIf="criteria.hasNumber" [icon]="faCheck"></fa-icon>
    1 number
  </p>
  <p [class.criteria-met]="criteria.hasSpecialChar">
    <fa-icon *ngIf="criteria.hasSpecialChar" [icon]="faCheck"></fa-icon>
    1 Special character (Optional)
  </p>
</div>